import { Component, OnInit } from '@angular/core';
import * as bootstrap from 'bootstrap';
import { Popover } from 'bootstrap'
import { CommonService } from 'src/app/services/common.service';
import { ExternalService } from 'src/app/services/external.service';
import { StorageService } from 'src/app/services/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';

@Component({
  selector: 'app-logo-toolbar',
  templateUrl: './logo-toolbar.component.html',
  styleUrls: ['./logo-toolbar.component.scss']
})
export class LogoToolbarComponent implements OnInit {

  constructor(
    public commonService:CommonService,
    private fb: FormBuilder,
    private externalServcie:ExternalService,
    public storageService:StorageService,
    public translate: TranslateService
  ) { 

  }

  ngOnInit(): void {

  }


  logOut(){
    var auth = this.storageService.getData('auth')
    var sessionId = this.storageService.getData('sessionId')
    this.externalServcie.logOut()
  }

  formGroup: FormGroup = this.fb.group({
    languaje: [this.translate.currentLang,Validators.required]
  })

}
